/**
 * @generated SignedSource<<94fcc25c4244836654a2ac586e69254e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerPresetConfigurationsPaginationQuery$variables = {
  after?: string | null;
  count?: number | null;
  modelID: number;
};
export type composerPresetConfigurationsPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"composerPresetConfigurations_list">;
};
export type composerPresetConfigurationsPaginationQuery = {
  response: composerPresetConfigurationsPaginationQuery$data;
  variables: composerPresetConfigurationsPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 60,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelID"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "modelID",
  "variableName": "modelID"
},
v3 = [
  (v1/*:: as any*/),
  {
    "kind": "Literal",
    "name": "draft",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "isTemplate",
    "value": true
  },
  (v2/*:: as any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": 1
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerPresetConfigurationsPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v2/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "composerPresetConfigurations_list"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "composerPresetConfigurationsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "CompositionsPagedConnection",
        "kind": "LinkedField",
        "name": "compositionsPaged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompositionsPagedEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Composition",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "compositionID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previewImageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompositionTemplateCategory",
                    "kind": "LinkedField",
                    "name": "categories",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "categoryID",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": [
          "page",
          "modelID",
          "isTemplate",
          "draft"
        ],
        "handle": "connection",
        "key": "composerPresetConfigurations_list_compositionsPaged",
        "kind": "LinkedHandle",
        "name": "compositionsPaged"
      }
    ]
  },
  "params": {
    "cacheID": "3a90f2d49972bf7defd2b04fdba7b0f2",
    "id": null,
    "metadata": {},
    "name": "composerPresetConfigurationsPaginationQuery",
    "operationKind": "query",
    "text": "query composerPresetConfigurationsPaginationQuery(\n  $after: String\n  $count: Int = 60\n  $modelID: Long!\n) {\n  ...composerPresetConfigurations_list_1zGMVt\n}\n\nfragment composerPresetConfigurations_list_1zGMVt on Query {\n  compositionsPaged(first: $count, after: $after, page: 1, modelID: $modelID, isTemplate: true, draft: false) {\n    edges {\n      node {\n        id\n        compositionID\n        name\n        previewImageUrl\n        categories {\n          categoryID\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cab7ef477af2ad43f1d8bf85e641607e";

export default node;
